import { c as _c } from "react/compiler-runtime";
import { NewsletterViewApiType } from 'modules/newsletters/single/types/newsletter-view-interface';
import { useEffect, useState } from 'react';
import { ContactsSettings } from 'shared/components/dashboard-mail-editor/components/contacts-settings-block';
export const useNewsletterContactsSettings = newsletterData => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      daysExists: 0,
      tags: {
        included: [],
        excluded: []
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [contactsSettings, setContactsSettings] = useState(t0);
  let t1;
  if ($[1] !== newsletterData.daysExists || $[2] !== newsletterData.excludedTags || $[3] !== newsletterData.tags) {
    t1 = () => {
      setContactsSettings({
        daysExists: newsletterData.daysExists,
        tags: {
          included: newsletterData?.tags?.map(_temp) || [],
          excluded: newsletterData?.excludedTags?.map(_temp2) || []
        }
      });
    };
    $[1] = newsletterData.daysExists;
    $[2] = newsletterData.excludedTags;
    $[3] = newsletterData.tags;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== newsletterData) {
    t2 = [newsletterData];
    $[5] = newsletterData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== contactsSettings) {
    t3 = {
      contactsSettings,
      setContactsSettings
    };
    $[7] = contactsSettings;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(t0) {
  const {
    id
  } = t0;
  return id;
}
function _temp2(t0) {
  const {
    id: id_0
  } = t0;
  return id_0;
}